// extracted by mini-css-extract-plugin
export default {"InfoBoxContainer":"_InfoBoxContainer--FBk7I","Link":"_Link--OvxR2"};